import { render, staticRenderFns } from "./ConfigurazioneContabilitaSoggettiListPage.vue?vue&type=template&id=3520ecd2"
import script from "./ConfigurazioneContabilitaSoggettiListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaSoggettiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports